const prodItemBundle = document.querySelector('.products__list--item.is-bundle');
const prodBundleInfo = prodItemBundle.querySelector('.product__info');
const bundleRadioSvg = prodItemBundle.querySelector('svg');
const originalItem = document.querySelector('.products__list--item.original-product');
const bullets = originalItem.querySelector('.bullet-list__wrapper');
const sellingPlans = originalItem.querySelector('.product-sellings-plans')
const freeOrderText = originalItem.querySelector('.free-order-text')
let rechargeWidget = null;
// prodBundleInfo.addEventListener('click', function (e) {
//   e.preventDefault();
//   if (prodItemBundle.classList.contains('is-selected')) {
//     return;
//   }
//   const selectedItem = document.querySelector('.products__list--item.is-selected');
//   const selectedItemVariants = selectedItem.querySelector('.product__form__holder');
//   // bullets?.remove();
//   const selectedRadioSvg = selectedItem.querySelector('svg');
//   selectedItem?.classList.remove('is-selected');
//   prodItemBundle?.classList.add('is-selected');
//   // selectedItemVariants?.remove();
//   // sellingPlans?.remove()
//   // freeOrderText?.remove()
//   //rechargeWidget?.remove();
//   selectedRadioSvg.innerHTML = bundleRadioSvg.innerHTML;
//   bundleRadioSvg.innerHTML = `<circle
//   cx="6"
//   cy="6"
//   r="5.5"
//   stroke="#F9946E" />
// <circle
//   cx="6"
//   cy="6"
//   r="2.5"
//   fill="#F9946E"
//   stroke="#F9946E" />`;
//   prodItemBundle.append(selectedItemVariants);
//   prodItemBundle.append(sellingPlans)
//   prodItemBundle.append(freeOrderText)
//   //rechargeWidget && prodItemBundle.append(rechargeWidget);
// });

function getRecharge() {
  setTimeout(function () {
    rechargeWidget = document.querySelector('.rc-container-wrapper');
    if (rechargeWidget) {
      rechargeWidget?.remove();
      selectedItem.append(rechargeWidget);
    } else {
      getRecharge();
    }
  }, 6000);
}


(function(){
  let selectedItemVariants = document.querySelector('.is-single .product__form__holder')
  document.querySelector('.products__list').addEventListener('click', (e) => {
    if(!e.target.closest('.products__list--item').classList.contains('is-selected')){
    let isBundle = e.target.classList.contains('is-bundle');
    
    const listItem = e.target.closest('.products__list--item');
    
    if (listItem) {
      const items = document.querySelectorAll('.products__list--item');
      items.forEach((item) => {
        item.classList.remove('is-selected');
      });
  
      listItem.append(selectedItemVariants);
      listItem.append(sellingPlans);
      listItem.append(freeOrderText);
      
      if (isBundle) {
        changeImage(1);
      } else {
        changeImage(0);
      }
      
      listItem.classList.add('is-selected');
    }
  }
  });
  
  document.addEventListener('DOMContentLoaded', () => {
    let selectedItemVariants = document.querySelector('.is-single .product__form__holder')
    let bundleItem = document.querySelector('.is-bundle');
    bundleItem.append(selectedItemVariants);
    bundleItem.append(sellingPlans);
    bundleItem.append(freeOrderText);
  })

  function changeImage(index){
    let allThumbs = document.querySelectorAll('.product__thumb');
    allThumbs.forEach(thumb => thumb.classList.remove('is-active'))
    var thumbElement = document.querySelector(`.product__thumb__link[data-thumb-index="${index}"]`);
    thumbElement.parentElement.classList.add('is-active');
    let imgSrc = thumbElement.querySelector('img').getAttribute('src')
    console.log(imgSrc);
    let allMainPhotos = document.querySelectorAll('.product__slide');
    allMainPhotos.forEach(photo => {
      photo.classList.remove('is-selected')
      if(photo.dataset.thumb == imgSrc){
        photo.classList.add('is-selected')
      }
    })
  }
})()